import { Grid2 as Grid } from "@mui/material";
import {
  GuideSection,
  FileUploadSection,
  DoJangSendSection,
  SendResultSection,
  CsvPreviewSection,
  CsvDataTable,
  EmailLogTable,
} from "@/organism/BulkEmail";

import { type CsvData } from "@/organism/BulkEmail/CsvDataTable/useCsvData";

/**
 * 발송 결과 인터페이스
 */
interface SendResults {
  total: number;
  successful: number;
  failed: number;
  errors?: Array<{
    email: string;
    error: string;
  }>;
}

/**
 * BulkEmail List Template Props
 */
interface BulkEmailListTemplateProps {
  csvFile: File | null;
  csvData: CsvData[];
  isUploading: boolean;
  isSending: boolean;
  sendProgress: number;
  sendResults: SendResults | null;
  selectedDoJangName: string;
  onFileUpload: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onSendEmails: () => void;
  onFileRemove: () => void;
  onDoJangChange: (doJangId: string, doJangName: string) => void;
}

/**
 * 이메일 대량 발송 리스트 템플릿
 * @description 이메일 대량 발송 기능의 UI 템플릿 컴포넌트입니다.
 * @author Max <sud665@ymjlab.com>
 * @version 1.0.0
 * @since 2025-01-15
 */
export const List = ({
  csvFile,
  csvData,
  isUploading,
  isSending,
  sendProgress,
  sendResults,
  selectedDoJangId,
  selectedDoJangName,
  onFileUpload,
  onSendEmails,
  onFileRemove,
  onDoJangChange,
}: BulkEmailListTemplateProps) => {
  return (
    <>
      {/* 안내 섹션 */}
      <GuideSection />

      <Grid container spacing={3}>
        {/* Step 1: CSV 파일 업로드 */}
        <Grid size={{ xs: 12, md: 6 }}>
          <FileUploadSection
            csvFile={csvFile}
            csvData={csvData}
            isUploading={isUploading}
            onFileUpload={onFileUpload}
            onFileRemove={onFileRemove}
          />
        </Grid>

        {/* Step 2: 도장 선택 및 발송 */}
        <Grid size={{ xs: 12, md: 6 }}>
          <DoJangSendSection
            csvFile={csvFile}
            isSending={isSending}
            sendProgress={sendProgress}
            onSendEmails={onSendEmails}
            onDoJangChange={onDoJangChange}
          />
        </Grid>

        {/* Step 3: 발송 결과 */}
        <Grid size={{ xs: 12 }}>
          <SendResultSection sendResults={sendResults} />
        </Grid>

        {/* CSV 데이터 간단 미리보기 */}
        {/* <Grid size={{ xs: 12, md: 6 }}>
          <CsvPreviewSection csvData={csvData} />
        </Grid> */}

        {/* CSV 데이터 상세 테이블 */}
        <Grid size={{ xs: 12, md: 12 }}>
          <CsvDataTable 
            csvData={csvData} 
            companyId={selectedDoJangId ? Number(selectedDoJangId) : undefined}
            enableRealTimeSync={!!selectedDoJangId && csvData.length > 0}
          />
        </Grid>

        {/* 방안 1: 별도 이메일 로그 테이블 (선택적으로 사용) */}
        {/* 
        <Grid size={{ xs: 12 }}>
          <EmailLogTable 
            companyId={selectedDoJangId ? Number(selectedDoJangId) : undefined}
            autoRefresh={true}
            refreshInterval={10}
          />
        </Grid>
        */}
      </Grid>
    </>
  );
};
